import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import AvatarOne from '../../../../Components/AvatarOne/AvatarOne'
import { Info, Send } from '@mui/icons-material'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext, useState } from 'react'
import PessoalInfoModal from '../../../../Components/PessoalInfoModal/PessoalInfoModal'
import EnviarMsgModal from '../../../../Components/EnviarMsgModal/EnviarMsgModal'
import ListClickToCall from './ListClickToCall'
import { keyframes } from '@emotion/react'

const CardPessoa = ({ pessoa, ramalImovel, tipo_licenca_cond }) => {
    const { addMoradorSelecionado } = useContext(VisitantesContext)
    const [openInfoPessoa, setOpenInfoPessoa] = useState(false)
    const [openEnviarMsg, setOpenEnviarMsg] = useState(false)

    return (
        <Grid sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '150px',
            height: '150px',
            // border: '1px solid black',
            margin: '5px',
            borderRadius: '5px',
            alignItems: 'space-between',
            justifyContent: 'space-between',
            alignContent: 'space-between',
            padding: '5px',
            cursor: 'pointer',
            backgroundColor: pessoa.bloqueado ? '#ffcccc' : 'white',
            boxShadow: '0px 2px 4px 1px rgba(0, 0, 0, 0.322)'
        }}>
            {openInfoPessoa &&
            <PessoalInfoModal
                openInfoPessoa={openInfoPessoa}
                setOpenInfoPessoa={setOpenInfoPessoa}
                pessoa={pessoa}
                facial={false}
            />
            }
            {openEnviarMsg &&
            <EnviarMsgModal
                openEnviarMsg={openEnviarMsg}
                setOpenEnviarMsg={setOpenEnviarMsg}
                pessoa={pessoa}
            />
            }
            <Grid onClick={() => { addMoradorSelecionado(pessoa) }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%'
                }}>
                    <div style={{ width: '30%' }}>
                        <Typography sx={ TypographySx }>{pessoa.prioridade}</Typography>
                    </div>
                    <div style={{ width: '70%' }}>
                        <AvatarOne borda={false} height={'60px'} width={'60px'} src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/web/images/${pessoa.IMAGEMPERFIL}`}/>
                    </div>
                </Grid>
                <Typography title={pessoa.nome} sx={ TypographySx }>
                   {pessoa.nome}
                </Typography>
                {pessoa.bloqueado &&
                    <Typography title="Bloqueado" sx={{ ...TypographySx, color: 'red' }}>
                        Bloqueado
                    </Typography>
                }
                <Typography title={pessoa.funcao} sx={TypographySx}>
                    {pessoa.funcao}
                </Typography>
            </Grid>
            <Grid sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-around'
            }}>
                <Info onClick={() => setOpenInfoPessoa(true)} sx={{
                    ...IconSx,
                    color: pessoa.obs && pessoa.obs != ''
                        ? 'red'
                        : 'black',
                    animation: pessoa.obs && pessoa.obs != '' ? `${blinkAnimation} 1s 3` : 'none'
                }}
                />
                <ListClickToCall pessoa={pessoa} ramalImovel={ramalImovel} tipo_licenca_cond={tipo_licenca_cond}></ListClickToCall>
                <Send sx={IconSx} onClick={() => { setOpenEnviarMsg(true) }} />
            </Grid>
        </Grid>
    )
}

export default CardPessoa

const TypographySx = {
    color: 'black',
    fontSize: '11px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
    textAlign: 'center',
    paddingLeft: '5px',
    paddingRight: '5px',
    boxSizing: 'border-box'
}

export const IconSx = {
    color: 'black',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    height: '20px',
    cursor: 'pointer'
}

const blinkAnimation = keyframes`
    0% {
        color: red;
    }
    33% {
        color: blue;
    }
    66% {
        color: red;
    }
    100% {
        color: red;
    }
`
